import { request } from '@/api/apiUtils';
import { LINE_PRESENTATIONS_ROOT } from '@/data/entities/lines';
import { useCreate, useCustomMutation, useDelete, useUpdate } from '@/data/mutations';
import type { CreateLineType, ILine, IScene, ResponseType, UpdateLineType, UpdateSceneLineOrderType } from '@/types';

export const useCreateLine = useCreate.line<CreateLineType, ResponseType<ILine>>({
    endpoint: ({ project_id }) => `projects/${project_id}/lines`,
    body: ({ title, color, code, text_atoms }) => ({ title, color, code, text_atoms }),
});

export const useUpdateLine = useUpdate.line<UpdateLineType, ResponseType<ILine>>({
    method: 'PATCH',
    endpoint: ({ project_id, id }) => `projects/${project_id}/lines/${id}`,
    body: params => ({ ...params, name: params.title }),
});

export const useDeleteLine = useDelete.line<{ project_id: number; line_id: number }, ResponseType<ILine>>({
    method: 'DELETE',
    endpoint: ({ project_id, line_id }) => `projects/${project_id}/lines/${line_id}`,
});

/**
 * Reorder a line within a specific scene. Targets only the line-presentations cache —
 * neither lines nor fountain caches need to refetch on a pure reorder.
 */
export function useUpdateSceneLineOrder() {
    return useCustomMutation<UpdateSceneLineOrderType, ResponseType<IScene>>({
        mutationFn: async params =>
            request<ResponseType<IScene>>(`projects/${params.project_id}/scenes/${params.scene_id}?_method=PUT`, {
                method: 'POST',
                body: JSON.stringify({
                    line_order: { line_id: params.line_id, order: params.line_order },
                }),
            }),
        invalidate: [LINE_PRESENTATIONS_ROOT],
    });
}
